import styled from "styled-components";
import { colors, font } from "../../styles/theme/tokens";

export const Wrapper = styled.div`
  width: 100%;
  max-height: 360px;
  overflow-y: auto;
  padding: 0 20px 18px 72px;

  @media (max-width: 560px) {
    padding: 0 18px 18px;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const Item = styled.li`
  display: flex;
`;

export const Text = styled.p`
  font-family: ${font.text};
  font-size: 15px;
  font-weight: 500;
  line-height: 1.55;
  color: ${colors.muted};
`;

export const TextBold = styled.span`
  font-weight: 800;
  color: ${colors.ink};
`;
